module.exports = __webpack_public_path__ + "img/tza.88c89454.svg";